import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Table, Tag, Space, Spin, Typography } from 'antd';
import {
  UserOutlined,
  TeamOutlined,
  DollarOutlined,
  RiseOutlined,
  FallOutlined
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import agentService from '../../services/agent.service';

const { Title } = Typography;

const Dashboard = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      setLoading(true);
      const response = await agentService.getDashboard();
      if (response && typeof response === 'object') {
        setDashboardData(response);
      } else {
        console.error('Invalid dashboard response:', response);
      }
    } catch (error) {
      console.error('載入儀表板資料失敗:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!dashboardData) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Typography.Text type="secondary">無法載入儀表板數據</Typography.Text>
      </div>
    );
  }

  const { agent, stats, creditInfo, commissionInfo } = dashboardData || {};

  return (
    <div>
      <Title level={2}>儀表板</Title>
      
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="可用額度"
              value={(creditInfo?.availableCredit !== '無限制' ? creditInfo?.availableCredit : agent?.availableCredit) || 0}
              prefix={<DollarOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="下級代理"
              value={stats?.subAgentsCount || 0}
              prefix={<TeamOutlined />}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="直屬會員"
              value={stats?.directMembersCount || 0}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="今日新增會員"
              value={stats?.todayNewMembers || 0}
              prefix={<RiseOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="今日投注統計">
            <Row gutter={16}>
              <Col span={8}>
                <Statistic
                  title="投注筆數"
                  value={stats?.todayBets || 0}
                  suffix="筆"
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="投注金額"
                  value={stats?.todayBetAmount || 0}
                  prefix="$"
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="盈虧"
                  value={stats?.todayWinLoss || 0}
                  prefix="$"
                  valueStyle={{ 
                    color: (stats?.todayWinLoss || 0) >= 0 ? '#3f8600' : '#cf1322' 
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title="帳戶資訊">
            <Space direction="vertical" style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>信用額度：</span>
                <strong>${(creditInfo?.creditLimit !== '無限制' ? creditInfo?.creditLimit : agent?.creditLimit) || 0}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>已使用額度：</span>
                <strong>${(creditInfo?.usedCredit || agent?.usedCredit) || 0}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>佔成率：</span>
                <strong>{(commissionInfo?.commissionRate || agent?.commissionRate) || 0}%</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>洗碼佣金率：</span>
                <strong>{(agent?.rebateRate || commissionInfo?.rebateRate) || 0}%</strong>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;